<template>
  <div>
    <PageHeader title="Events">
      <el-input
        prefix-icon="el-icon-search"
        placeholder="Search"
        v-model="searchVal"
        v-debounce="onSearch"
        clearable
        @clear="onSearch"
      />
      <el-button type="primary" icon="el-icon-plus" @click="newEventDialog()"
        >New Event</el-button
      >
    </PageHeader>
    <div class="padding-lr">
      <el-table
        ref="table"
        :data="tableData"
        @sort-change="onSortChange"
        @selection-change="handleSelectionChange"
      >
        <el-table-column prop="Subject" label="Subject" sortable="custom" />
        <el-table-column
          prop="StartDateTime"
          label="Start Date"
          sortable="custom"
          :formatter="dateFormatter"
        />
        <el-table-column
          prop="EndDateTime"
          label="End Date"
          sortable="custom"
          :formatter="dateFormatter"
        />
        <el-table-column prop="Deleted" label="Status" sortable="custom">
          <template slot-scope="scope">
            <el-button v-if="scope.row.Deleted" type="info" round
              >Freeze</el-button
            >
            <el-button v-if="!scope.row.Deleted" type="success" round
              >Activate</el-button
            >
          </template>
        </el-table-column>

        <el-table-column
          label="Operation"
          width="115"
          prop="StatusDesc"
          align="center"
        >
          <template slot-scope="{ row }" prop="StatusDesc">
            <OptionMenu icon="iconfont icon-more-menu" iconSize="18">
              <OptionMenuItem
                title="View"
                icon="el-icon-view"
                @click="viewEventDialog(row)"
              />
              <OptionMenuItem
                icon="el-icon-edit"
                title="Edit"
                @click="editEventDialog(row)"
              />
              <OptionMenuItem
                v-show="row.Deleted"
                icon="iconfont icon-activate"
                title="Activate"
                @click="changeActivate(row)"
              />
              <OptionMenuItem
                v-show="!row.Deleted"
                icon="iconfont icon-stop"
                title="Freeze"
                @click="changeToFreeze(row)"
              />
            </OptionMenu>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </div>
    <EventNewDialog
      :visible.sync="newEventDialogVisible"
      :data.sync="editRow"
      @success="onSuccess"
    />
    <EventEditDialog
      :visible.sync="editEventDialogVisible"
      :data.sync="editRow"
      @success="onSuccess"
    />
    <EventViewDialog
      :visible.sync="viewEventDialogVisible"
      :data.sync="editRow"
      @success="onSuccess"
    />
  </div>
</template>

<script>
import moment from "moment";
import EventNewDialog from "../event/new-event-dialog";
import EventEditDialog from "../event/edit-event-dialog";
import EventViewDialog from "../event/view-event-dialog";
export default {
  name: "Event-Management",
  components: { EventNewDialog, EventEditDialog, EventViewDialog },
  data() {
    return {
      searchVal: "",
      dateFormat: "YYYY-MM-DD HH:mm",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      frozen: true,
      active: false,
      Frozen: false,
      orderBy: "CreatedOn",
      orderType: "descending",
      editRow: null,
      newEventDialogVisible: false,
      editEventDialogVisible: false,
      viewEventDialogVisible: false,
      tableData: [],
    };
  },
  created() {
    this.getTableData();
    this.bus.$on("refresh", ({ name }) => {
      if (this.$options.name === name) {
        this.getTableData();
      }
    });
  },
  mounted() {},
  methods: {
    getTableData() {
      this.tableLoading = true;
      let params = {
        pageSize: this.pageSize,
        page: this.currentPage,
        key: this.searchVal,
        orderBy: this.orderBy,
        orderType: this.orderType,
      };
      this.axios
        .get(`/event/list`, { params: params })
        .then(({ code, data, msg }) => {
          if (200 === code) {
            this.tableData = data.data;
            this.total = data.total;
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    onSearch() {
      this.currentPage = 1;
      this.getTableData();
    },
    dateFormatter(row, column, cellValue) {
      return moment(new Date(cellValue)).format(this.dateFormat);
    },
    newEventDialog() {
      this.newEventDialogVisible = true;
    },
    editEventDialog(row) {
      this.editRow = row;
      this.editEventDialogVisible = true;
    },
    changeActivate(row) {
      let params = {
        status: 0,
        actId: row.ActivityID,
      };
      this.axios
        .get(`/event/freeze`, {
          params: params,
        })
        .then(({ code, msg }) => {
          if (code === 200) {
            this.$emit("success");
            this.$message.success(`Activate event successfully`);
            this.getTableData();
          } else {
            this.$message.error(msg);
          }
        });
    },
    changeToFreeze(row) {
      let params = {
        status: 1,
        actId: row.ActivityID,
      };
      this.axios
        .get(`/event/freeze`, {
          params: params,
        })
        .then(({ code, msg }) => {
          if (code === 200) {
            this.$emit("success");
            this.$message.success(`Freeze event successfully`);
            this.getTableData();
          } else {
            this.$message.error(msg);
          }
        });
    },
    viewEventDialog(row) {
      this.editRow = row;
      this.viewEventDialogVisible = true;
    },
    onSortChange(column) {
      this.orderBy = column.prop;
      this.orderType = column.order;
      this.getTableData();
    },
    handleSelectionChange() {},
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
    },
    onSuccess() {
      this.getTableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.el-button--mini.is-round {
  padding: 3px 15px;
}
</style>
